module.exports = __webpack_public_path__ + "img/00 banner.1bc16420.png";